import { IChangedSteps } from '../../models/IChangedSteps'

export const isExistsChangedSteps = (changedSteps: IChangedSteps) => {
  return Object.values(changedSteps).some((isChanged) => isChanged)
}
